import type { CarWheelMeasurementListApiData } from '@navio/nsdk';
import { filterUnitFor, useFilterUnits } from 'noddi-ui-web';
import { CAR_WHEEL_MEASUREMENT_TYPE_OPTIONS, INSPECTION_SOURCE_OPTIONS, TIRE_SEASON_OPTIONS } from 'noddi-util';
import { CREATED_AT_FILTER_TEXT } from '../Date/useCreatedAtFilter';
import {
  SERVICE_DEPARTMENT_FILTER_TEXT,
  useServiceDepartmentOptions
} from '../ServiceDepartment/useServiceDepartmentFilter';

const unit =
  filterUnitFor<
    Omit<NonNullable<CarWheelMeasurementListApiData['query']>, 'pageIndex' | 'pageSize' | 'ordering' | 'search'>
  >();

/** Departments the measurements are limited to, for apps that show one organization only. */
export type CarWheelMeasurementTableScope = { serviceDepartmentIds: number[] };

export const useCarWheelMeasurementTableFilters = (scope?: CarWheelMeasurementTableScope) => {
  const departments = unit.multiSelect('serviceDepartmentIds', {
    ...SERVICE_DEPARTMENT_FILTER_TEXT,
    source: useServiceDepartmentOptions(),
    exclude: true
  });
  return useFilterUnits([
    scope && unit.locked(scope),
    !scope && departments,
    unit.multiSelect('measurementType', {
      title: 'Measurement type',
      description: 'Filter by what was measured',
      options: CAR_WHEEL_MEASUREMENT_TYPE_OPTIONS,
      exclude: true
    }),
    unit.multiSelect('tireSeason', {
      title: 'Season',
      description: 'Filter by the season the reading was attributed to',
      options: TIRE_SEASON_OPTIONS,
      exclude: true
    }),
    unit.multiSelect('sources', {
      title: 'Source',
      description: 'Filter by measurement origin',
      options: INSPECTION_SOURCE_OPTIONS,
      exclude: true
    }),
    unit.numberRange('value', {
      title: 'Value',
      description: 'Filter by measured value, in the unit of the measurement type',
      exclude: true
    }),
    unit.dateRange('measuredAt', {
      title: 'Measured at',
      description: 'Filter by when the measurement was taken',
      exclude: true
    }),
    unit.dateRange('createdAt', { ...CREATED_AT_FILTER_TEXT, exclude: true })
  ]);
};
